import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  z-index: -1;
  bottom: 0;
  left: 0;
  right: 0;

  img {
    width: 100%;
    height: 20%;
  }
`;